module.exports = __webpack_public_path__ + "static/media/aimee_challies_mood.48a8e343.jpeg";